module.exports = __webpack_public_path__ + "img/1.0efa1bd1.png";